import { useState, useEffect } from 'react';

// Read the Google ID token the auth hook stored, to authenticate to /api/patients.
function storedToken() {
  try { return JSON.parse(localStorage.getItem('sm_user') || '{}').token || null; }
  catch { return null; }
}

// Fetch the live roster + Action Group membership from the backend and index it
// by group_key. Returns { groups, counts, patients, updatedAt, loading, error }.
// groups[key] is an array of patient objects (a patient can appear in several).
export function usePatients() {
  const [state, setState] = useState({
    groups: {}, counts: {}, patients: [], updatedAt: null, loading: true, error: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = storedToken();
        const res = await fetch('/api/patients', {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) {
          throw new Error(res.status === 401
            ? 'Session expired — please sign out and back in.'
            : `Could not load patients (${res.status}).`);
        }
        const data = await res.json();
        if (cancelled) return;
        const groups = {};
        for (const p of data.patients || []) {
          for (const g of p.groups || []) (groups[g] || (groups[g] = [])).push(p);
        }
        setState({
          groups, counts: data.counts || {}, patients: data.patients || [],
          updatedAt: data.updatedAt || null, loading: false, error: null,
        });
      } catch (e) {
        if (!cancelled) setState((s) => ({ ...s, loading: false, error: e.message }));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return state;
}
